import React, { useEffect, useState } from 'react';
import { AppIcons } from "../../../data/appIcons";
import Image from "../../image/Image";
import "./SidebarModel.scss";
import PropTypes from 'prop-types';

const SidebarModel = ({ children, modalTitleIcon, useCustomBg, ...props }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    if (props.isOpen) {
      setIsVisible(true);

      const timer = setTimeout(() => {
        setIsTransitioning(true);
      }, 200);
      return () => clearTimeout(timer);
    } else {
      setIsTransitioning(false);

      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [props.isOpen]);

  if (!isVisible) return null;

  return (
    <div className={`sidebar-model ${isTransitioning ? "active-model" : ""} ${useCustomBg ? 'custom-bg-color' : ''}`}>
      <div className="right-model-section">
        <div className={`model-content ${props.contentClass}`}>
          <div className="model-header">
            <span className="modal-icon">
              <Image imagePath={modalTitleIcon} altText="Title Icon" />
            </span>
            <div className="model-title">{props.modalTitle}</div>
            <button
              className="close-btn"
              onClick={props.onClose ? props.onClose : null}
            >
              <Image
                imgCustomClassName="default"
                imagePath={AppIcons.CloseIcon}
                altText="Close"
              />
            </button>
          </div>
          <div className="model-body">
            <div className="body-center">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

SidebarModel.propTypes = {
  children: PropTypes.node.isRequired,
  modalTitleIcon: PropTypes.string.isRequired,
  useCustomBg: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  modalTitle: PropTypes.string.isRequired,
  contentClass: PropTypes.string,
};

export default SidebarModel;
